/* eslint-disable max-len */
import React from 'react';
import CmsContent from 'components/CmsContent';

export default function Terms() {
  return <CmsContent pageName="termsandconditions" />;
}

Terms.displayName = 'Terms';
